// This will allow to determine when individual speeches within a transaction start and stop
export const EVENT_TYPE_SPEECH_START = "speech-start";
export const EVENT_TYPE_SPEECH_PAUSED = "speech-paused";
export const EVENT_TYPE_SPEECH_FINISH = "speech-finish";

// These events pertain to the whole transaction, a transaction contains one or more speech requests
export const EVENT_TYPE_SPEECH_TRANSACTION_START = "speech-transaction-start";
export const EVENT_TYPE_SPEECH_TRANSACTION_PAUSED = "speech-transaction-paused";
export const EVENT_TYPE_SPEECH_TRANSACTION_FINISH = "speech-transaction-finish";

export const SYNTHETIC_VOICE_TYPE_AUDIO = "audio";
export const SYNTHETIC_VOICE_TYPE_TEXT_TO_SPEECH = "tts";

// Each player/engine has its own range from slowest to fastest,
// therefore we will be providing these
export const VOICE_SPEED_NORMAL = "normal";
export const VOICE_SPEED_SLOW = "slow";
export const VOICE_SPEED_SLOWER = "slower";
export const VOICE_SPEED_SLOWEST = "slowest";
export const VOICE_SPEED_FAST = "fast";
export const VOICE_SPEED_FASTER = "faster";
export const VOICE_SPEED_FASTEST = "fastest";

export const VOICE_SPEEDS = [
	VOICE_SPEED_SLOWEST,
	VOICE_SPEED_SLOWER,
	VOICE_SPEED_SLOW,
	VOICE_SPEED_NORMAL,
	VOICE_SPEED_FAST,
	VOICE_SPEED_FASTER,
	VOICE_SPEED_FASTEST
]

export const NUM_VALUE_TO_VOICE_SPEED = {
	0: VOICE_SPEED_SLOWEST,
	18: VOICE_SPEED_SLOWER,
	34: VOICE_SPEED_SLOW,
	50: VOICE_SPEED_NORMAL,
	66: VOICE_SPEED_FAST,
	82: VOICE_SPEED_FASTER,
	100: VOICE_SPEED_FASTEST
}